import * as angular from "angular";

const FOCUS_TARGET_SELECTOR = "[restore-focus-target]";

interface RestoreFocusWhenAttributes extends angular.IAttributes {
	restoreFocusWhen: string;
}

class RestoreFocusWhenDirective implements angular.IDirective {
	public restrict = "A";

	public link(
		scope: angular.IScope,
		element: angular.IAugmentedJQuery,
		attributes: RestoreFocusWhenAttributes
	): void {
		const container = element[0];
		const unwatch = scope.$watch(
			() => scope.$eval(attributes.restoreFocusWhen),
			(shouldRestore, previouslyShouldRestore) => {
				if(previouslyShouldRestore !== false || shouldRestore !== true) {
					return;
				}

				const activeElement = container.ownerDocument.activeElement;
				if(!activeElement || !container.contains(activeElement)) {
					return;
				}

				const focusTarget = container.querySelector<HTMLElement>(FOCUS_TARGET_SELECTOR);
				if(!focusTarget || focusTarget === activeElement) {
					return;
				}

				scope.$evalAsync(() => {
					if(focusTarget.ownerDocument.contains(focusTarget)) {
						focusTarget.focus();
					}
				});
			}
		);

		scope.$on("$destroy", unwatch);
	}
}

export default angular
	.module("vesl.behaviors.restore-focus-when", [])
	.directive("restoreFocusWhen", () => new RestoreFocusWhenDirective())
	.name;
